import React from 'react';

import SocialLoginPanel from '../../../components/SocialLoginPanel';

type Props = {
  isEmbedded: boolean;
  isSocialBlocked: boolean;
  envSupportsSocialLogin: boolean;
  onGoogleLogin: () => void;
  onMicrosoftLogin: () => void;
  onAppleLogin: () => void;
  onSlackLogin: () => void;
};

const MaybeSocialLoginPanel = ({
  isEmbedded,
  isSocialBlocked,
  envSupportsSocialLogin,
  onGoogleLogin,
  onMicrosoftLogin,
  onAppleLogin,
  onSlackLogin,
}: Props) => {
  if (!envSupportsSocialLogin || isEmbedded || isSocialBlocked) {
    return null;
  }

  return (
    <SocialLoginPanel
      handleGoogleLogin={onGoogleLogin}
      handleMicrosoftLogin={onMicrosoftLogin}
      handleAppleLogin={onAppleLogin}
      handleSlackLogin={onSlackLogin}
    />
  );
};

export default MaybeSocialLoginPanel;
